import { Injectable } from '@angular/core';

import { WebService } from './web.service';
import { LoginInfoProvider } from '../ev-dal/login-info.provider';
import { NotificationService } from './notification.service';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  staticEntities = [];                   // all static entities from server

  constructor(
    private webService: WebService,
    private notificationService: NotificationService,
    private authService: LoginInfoProvider,
  ) { }

  // get all schemas of entities from server
  getAllStaticEntities() {
    const requestBody = {
      classTypeNames: [
        // TestScores entities
        'PSAT/NMSQT',
        'Pre ACT',
        'ACT',
        'AP',
        'SAT',
        'SAT Subjects',
        'SAT subject options',
        'AP subject options',
        'Student Grade',

        // States entities
        'West States',
        'SouthWest States',
        'MidWest States',
        'South States',
        'Mid-Atlantic States',
        'New England States',

        // Student profile
        'Work Experience',
        'Phone Numbers',
        'Class Size',
        'Subject',
        'State',
        'Gender',
        'Ethnicity',
        'Graduation Month',
        'Careers',
        'Special Considerations',
        'City Size',
        'Major',
        'Number of Years Elective',
        'Music',
        'Class Rank',
        'Sports',
        'ROTC',
        'High School',
        'Club Activities',
        'Other Club Activities',


        // Other entities
        'Brick Temperature',
        'Document Type'
      ],
      userId: this.authService.userId,
      partnerId: this.authService.partnerId
    };



    return this.webService.post('admin/valuesbylist', requestBody)
      .subscribe(
        (data: any) => {
          this.staticEntities = data.item;
          localStorage.setItem('envisionEntities', JSON.stringify(data.item));
        },
        () => {
          this.notificationService.show('error', 'Error while fetching static entities');
        });
  }

  // get entity schema by name
  getEntity(name: string) {

    const result = this.staticEntities.find(element => element.text === name);

    if (result) {
      return result;
    }

    const schemas = localStorage.getItem('envisionEntities');

    if (schemas) {
      const localResult = JSON.parse(schemas).find(element => element.text === name);

      if (localResult) {
        return localResult;
      }
    }

    this.notificationService.show('error', `Error when fetching schema of ${name} entity`);

    return {};
  }
}
